import { shopAPI } from 'commons/api/shop/shopAPI.js';

export const AboutPageData = {
  beforeCreate() {
    if (!this.$store.state.shop.shopSavable.clientData.aboutPage) {
      this.$store.commit('shop/addDynamicSection', {
        key: 'aboutPage',
        initialData: {},
      });

      shopAPI.getAboutPage(this.$store).then((data) =>
        this.$store.commit('shop/updateSectionOriginalData', {
          sectionKey: 'aboutPage',
          origData: data,
        }),
      );
    }
  },
  computed: {
    aboutPage() {
      return this.$store.state.shop.shopSavable.clientData.aboutPage || {};
    },
  },
};
